import { render, staticRenderFns } from "./AnnotatorContext.vue?vue&type=template&id=562914aa"
import script from "./AnnotatorContext.vue?vue&type=script&lang=js"
export * from "./AnnotatorContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports